import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { ForgetPasswordService } from './forget-password.service';
import { Routes, RouterModule, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.scss'],
    standalone: false
})
export class ForgetPasswordComponent implements OnInit {
  forgetForm: UntypedFormGroup;
  @ViewChild('emailName') emailName: ElementRef;

  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: UntypedFormBuilder,
    private forgetPasswordService: ForgetPasswordService,
    private router: Router,
    private authService: AuthService
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['']);
    }
  }
  get f() {
    return this.forgetForm.controls;
  }
  public showmessage: Boolean = false; // show message after submit
  public messagetext: String; // message text after submit
  public showFailMessage: Boolean = false;

  Resetview() {
    this.forgetForm.get('email').reset();
    this.showFailMessage = false;
    this.showmessage = false;
  }

  // after click on cancel button
  // redirect to login button

  onSubmit() {
    if (this.forgetForm.invalid) {
      return;
    }
    this.spinner.show();
    this.forgetPasswordService
      .forgetPassword(this.forgetForm.value.email)
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.status === 1) {
            this.messagetext =
              'Email has been sent to registered email id. Please check';
            this.showmessage = true;
          } else if (res.status === 0) {
            this.showFailMessage = true;
            this.messagetext = res.message;
          } else {
            this.showFailMessage = true;
            this.messagetext =
              'There is some problem with our server.Please contact administator or try after some time';
          }
        },
        error => {}
      );
  }

  ngOnInit() {
    this.forgetForm = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.pattern('^([a-zA-Z0-9_.\-]+)@([a-zA-Z0-9_.\-]+)[.]([a-zA-Z]{2,})$'), Validators.maxLength(100)]
      ]
    });
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.emailName.nativeElement.focus();
  }
}
